import React, { useEffect, useState } from 'react';
import { eventsEmit } from '../services/appboxService';
import closeDialogIcon from '../assets/images/trains/kinds/ic_close_dialog.svg';
import imgLegendTrainPosition from '../assets/images/trains/kinds/img_legend_train_position.png';
import imgLegendKonzatsu from '../assets/images/trains/kinds/img_legend_konzatsu.png';
import icLegendRapid from '../assets/images/trains/kinds/ic_legend_rapid.svg';
import icLegendCommuterRapid from '../assets/images/trains/kinds/ic_legend_com_r.svg';
import icLegendSectionRapid from '../assets/images/trains/kinds/ic_legend_semi_r.svg';
import icLegendLocal from '../assets/images/trains/kinds/ic_legend_local.svg';
import icLegendTx1000 from '../assets/images/trains/kinds/ic_legend_tx1000.svg';
import icLegendTx2000 from '../assets/images/trains/kinds/ic_legend_tx2000.svg';
import icLegendTx2000Zoubi from '../assets/images/trains/kinds/ic_legend_tx2000_zoubi.svg';
import icLegendTx3000 from '../assets/images/trains/kinds/ic_legend_tx3000.svg';
import { CROWD_LEVELS } from '../data/crowdLevels';

const TRAIN_KINDS = [
  { src: icLegendRapid, label: '快速' },
  { src: icLegendCommuterRapid, label: '通勤快速' },
  { src: icLegendSectionRapid, label: '区間快速' },
  { src: icLegendLocal, label: '普通' },
];

const TRAIN_MODELS = [
  { src: icLegendTx1000, label: 'TX-1000系' },
  { src: icLegendTx2000, label: 'TX-2000系' },
  { src: icLegendTx2000Zoubi, label: 'TX-2000系\n(増備車)' },
  { src: icLegendTx3000, label: 'TX-3000系' },
];

const SEGMENTS = ['列車走行位置', '混雑度'];

const Kinds = () => {
  const [activeSegment, setActiveSegment] = useState(0);

  useEffect(() => {
    import('../assets/stylesheets/trains/kinds.css')
      .then(() => {})
      .catch(err => console.error("CSSの読み込みエラー", err));

    eventsEmit('guide.screen', {});
  }, []);

  return (
    <div>
      <main className="main-container">
        <div className="half-modal">
          <div className="half-modal-window">
            <div className="modal-header">
              <h2 className="modal-header-title">ガイド</h2>
              <a
                href="/lines/mainline/trains"
                className="close-button"
                onClick={(event) => {
                  event.preventDefault();
                  eventsEmit('guide.close', {});
                  window.location.href = event.currentTarget.href;
                }}
              >
                <img src={closeDialogIcon} alt="Close Dialog" />
              </a>
            </div>
            <div className="modal-content">
              <div className="segment-control">
                {SEGMENTS.map((label, i) => (
                  <button
                    key={label}
                    className={`segment-control-item${activeSegment === i ? ' is-active' : ''}`}
                    onClick={() => setActiveSegment(i)}
                  >
                    {label}
                  </button>
                ))}
              </div>

              <div className={`segment-panel${activeSegment === 0 ? ' is-active' : ''}`}>
                <figure className="guide-diagram">
                  <img src={imgLegendTrainPosition} width="320" height="112" className="img-kinds-train guide-img" alt="Train Position Legend" />
                  <figcaption className="guide-caption">遅延している場合、列車アイコンに遅延時分が表示されます。</figcaption>
                </figure>
                <div className="guide-legend-row">
                  <div className="guide-legend-group">
                    <p className="guide-legend-title">種別</p>
                    <ul className="guide-legend-list">
                      {TRAIN_KINDS.map(({ src, label }) => (
                        <li key={label} className="guide-legend-type">
                          <img src={src} className="guide-legend-type-icon" alt={label} />
                          <span className="guide-legend-label">{label}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="guide-legend-group">
                    <p className="guide-legend-title">車型</p>
                    <ul className="guide-legend-list">
                      {TRAIN_MODELS.map(({ src, label }, i) => (
                        <li key={i} className="guide-legend-model">
                          <img src={src} className="guide-legend-model-icon" alt="" />
                          <span className="guide-legend-label">
                            {label.split('\n').map((line, j) => (
                              j === 0 ? line : <React.Fragment key={j}><br />{line}</React.Fragment>
                            ))}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="guide-legend-row">
                  <div className="guide-legend-group">
                    <p className="guide-legend-title">行先の表示について</p>
                    <p className="guide-legend-text">
                      駅名の先頭1文字を表示しています。<br />
                      秋葉原→秋、北千住→北、八潮→八、流山おおたかの森→流、守谷→守、つくば→つ
                    </p>
                  </div>
                </div>
                <p className="guide-legend-note">
                  ※実際の走行位置、行先、種別、車型、遅延時分とは異なる場合がございます。
                </p>
                <p className="guide-legend-note">
                  ※始発駅については、遅延時分を反映した到着見込みが表示されません。
                </p>
              </div>

              <div className={`segment-panel${activeSegment === 1 ? ' is-active' : ''}`}>
                <figure className="guide-diagram">
                  <img src={imgLegendKonzatsu} width="320" height="112" className="img-kinds-train guide-img" alt="混雑度の凡例" />
                  <figcaption className="guide-caption">全号車の平均混雑率を表示しております。</figcaption>
                </figure>
                <div className="guide-legend-row">
                  <div className="guide-legend-group">
                    <p className="guide-legend-title">混雑度</p>
                    <ul className="guide-legend-list">
                      {CROWD_LEVELS.map(({ level, icon, label }) => (
                        <li key={level} className="guide-legend-crowd-level">
                          <img src={icon} width="32" height="32" className="guide-legend-crowd-level-icon" alt={label} />
                          <span className="guide-legend-divider"></span>
                          <span className="guide-legend-label">{label}</span>
                        </li>
                      ))}
                    </ul>
                    <p className="guide-legend-text">
                      ※混雑度は約5分前の情報です。実際の混雑状況とは異なる場合がございます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Kinds;
